export function convertDateTimeToDateOnlyString(date: Date): string {
  // get rid of time part by creating new date that will not have TZ info
  const utcDateOnly = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

  // return date only string in YYYY-MM-DD format
  return utcDateOnly.toISOString().split('T')[0];
}
